import { RenderElementProps } from 'slate-react';

export interface BulletPointPluginOptions {
  isReadOnly?: boolean;
}

export interface BaseBulletPointPluginProps extends RenderElementProps, BulletPointPluginOptions {}

export const ELEMENT_BULLET_POINT = 'ul';
export const ELEMENT_BULLET_POINT_CHECK = 'ul-check';
export const ELEMENT_BULLET_POINT_X = 'ul-x';
export const ELEMENT_BULLET_POINT_QUESTION = 'ul-question';
export const ELEMENT_BULLET_POINT_NUMBER = 'ol';
export const ELEMENT_BULLET_POINT_LIST_ITEM = 'li';
